/**
 * Helper functions to get query params from route props.
 */

/**
 * getMatchObject
 * Gets the match object from the props of a routed component.
 * @param { Object } propsFromRoute: The props passed back from the routed component.
 * @returns { Object } The match object.
 */
export const getMatchObject = (propsFromRoute) => propsFromRoute.match || {};

/**
 * getParams
 * Gets the params object from the props of a routed component.
 * @param { Object } propsFromRoute: The props passed back from the routed component.
 * @returns { Object } The params object.
 */
export const getParams = (propsFromRoute) => {
  const matchObject = getMatchObject(propsFromRoute);
  return matchObject.params || {};
};

/**
 * getQueryParam
 * Gets the query param from the props of a routed component.
 * @param { Object } propsFromRoute: The props passed back from the routed component.
 * @param { String } param: The param to get.
 * @param { String } defaultValue: If param does not exist, return defaultValue.
 * @returns { Object } The query param.
 */
export const getQueryParam = (propsFromRoute, param, defaultValue) => {
  const params = getParams(propsFromRoute);
  return params[param] || defaultValue;
};
